import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    http
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        toast.success(`Welcome, ${r.data.name?.split(" ")[0] || "shopper"}!`);
        navigate("/", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        toast.error("Sign-in failed, please try again");
        navigate("/", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center text-[#878787]" data-testid="auth-callback">
      Signing you in…
    </div>
  );
};

export default AuthCallback;
